import type * as React from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium leading-none ring-offset-background transition-all duration-200 ease-out-expo focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-accent",
        destructive:
          "border-transparent bg-healthcare-critical/12 text-healthcare-critical ring-1 ring-inset ring-healthcare-critical/25 hover:bg-healthcare-critical/16",
        success:
          "border-transparent bg-healthcare-success/14 text-healthcare-success ring-1 ring-inset ring-healthcare-success/25 hover:bg-healthcare-success/18",
        warning:
          "border-transparent bg-healthcare-warning/16 text-[hsl(36_95%_30%)] ring-1 ring-inset ring-healthcare-warning/30 hover:bg-healthcare-warning/22",
        info: "border-transparent bg-healthcare-info/12 text-healthcare-info ring-1 ring-inset ring-healthcare-info/25 hover:bg-healthcare-info/16",
        outline: "border-border/80 bg-background text-foreground hover:bg-accent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
